module.exports = __webpack_public_path__ + "img/VN.6336b346.png";